// extracted by mini-css-extract-plugin
export default {"container":"PokeInfo_container__aCYzV"};